import React from 'react';
import ReactApexChart from "react-apexcharts"

class MyProgress extends React.Component {
  constructor(props) {
    super(props);
    const zoomAttend = this.normalizeScore(props.zoomAttend);
    const quizzes = this.normalizeScore(props.quizzes);
    const assigments = this.normalizeScore(props.assigments);
    const projects = this.normalizeScore(props.projects);
    const gat = this.normalizeScore(props.gat);
    const categories = ['Zoom Sessions', 'Quizzes', 'Assignments', 'Projects', 'GAT'];
    const chartColors = ['#2563eb', '#10b981', '#f59e0b', '#8b5cf6', '#ef4444'];

    this.state = {
      series: [{
        data: [zoomAttend, quizzes, assigments, projects, gat]
      }],
      options: {
        chart: {
          type: 'bar',
          height: 280,
          toolbar: {
            show: false
          },
          fontFamily: 'Inter, "Segoe UI", Roboto, Helvetica, Arial, sans-serif'
        },
        plotOptions: {
          bar: {
            borderRadius: 6,
            barHeight: '58%',
            distributed: true,
            horizontal: true,
            dataLabels: {
              position: 'center'
            }
          }
        },
        colors: chartColors,
        grid: {
          borderColor: '#e9edf3',
          strokeDashArray: 4,
          xaxis: {
            lines: {
              show: true
            }
          },
          yaxis: {
            lines: {
              show: false
            }
          }
        },
        dataLabels: {
          enabled: true,
          textAnchor: 'middle',
          style: {
            colors: ['#ffffff'],
            fontSize: '12px',
            fontWeight: 600
          },
          formatter: function (val, opt) {
            return `${opt.w.globals.labels[opt.dataPointIndex]}: ${val}%`
          },
          offsetX: 0
        },
        stroke: {
          width: 1.5,
          colors: ['#ffffff']
        },
        xaxis: {
          categories,
          max: 100,
          labels: {
            style: {
              colors: '#64748b',
              fontSize: '11px'
            },
            formatter: value => `${value}%`
          },
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          }
        },
        yaxis: {
          labels: {
            show: false
          }
        },
        legend: {
          show: false
        },
        tooltip: {
          theme: 'light',
          y: {
            title: {
              formatter: () => ''
            },
            formatter: value => `${value}%`
          },
          marker: {
            show: true
          }
        },
        states: {
          hover: {
            filter: {
              type: 'lighten',
              value: 0.05
            }
          }
        }
      }
    };
  }

  normalizeScore = value => {
    const numberValue = Number(value);
    if (Number.isNaN(numberValue)) return 0;
    return Math.max(0, Math.min(100, Math.round(numberValue)));
  };

  render() {
    return (
      <div id="chart">
        <ReactApexChart options={this.state.options} series={this.state.series} type="bar" height={244} />
      </div>
    )
  }
}
export default MyProgress
